module.exports = __webpack_public_path__ + "img/FooterNeurovi.800b98aa.png";